var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_460_691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0475 2.40848L21.5892 8.95022L16.6912 13.8482H3.60677L15.0475 2.40848ZM0.00390625 0H9.25558V6.92705L2.33411 13.8482H0.00390625V0ZM23.996 24H0.00390625V23.9929V14.7483H23.996V24ZM4.62925 21.4183C5.75692 21.4183 6.67389 20.5015 6.67389 19.3747C6.67389 18.2472 5.75608 17.3301 4.62799 17.3301C3.50139 17.3301 2.58442 18.2472 2.58442 19.374C2.58353 19.9197 2.79658 20.4325 3.18133 20.8184C3.56809 21.2052 4.0825 21.4183 4.62925 21.4183Z",
    fill: "#C32A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.f35dd7b4bab4c8bedb82fc36a70890cc.svg";
export { ForwardRef as ReactComponent };